import React, { ReactNode } from "react";
import { DialogActions } from "@mui/material";

import "./style.scss";

interface IDialogActionsWithOptionProps {
    disableSpacing?: boolean;
    children: ReactNode;
}

export const DialogActionsWithOption = (props: IDialogActionsWithOptionProps) => {
    return <div className={"dialog-actions"}>
        <DialogActions disableSpacing={props.disableSpacing} className={"dialog-actions__container"}>
            {props.children}
        </DialogActions>
    </div>;
};
